import {StoreExt} from '@utils/reactExt'
import {observable, action, computed} from 'mobx'
import {deepClone} from '@src/utils';

class UpgradeStore extends StoreExt {
    @observable effectiveNow: string // 是否支持本月生效,控制展示不展示
    @observable isEffectCurrentMonth = '0'  // 是否本月生效，控制选择
    @observable serviceGoodsList: any[] = []  // 服务商品列表
    @observable currentServiceGoodsId: string = '' // 当前选中的服务商品
    @observable currentServiceGoodsInfo: string[] = [] // 当前选中服务商品说明
    @observable costInfo: any = {}  // 价格信息
    @observable upgradeType: 'all' | 'other' = 'all' // 升级类型 all升级全部月，other选择升级的月数
    @observable months: number = 6
    @observable unitPrice: number = 0

    @computed get currentServiceGoodsName() {
        const goodsItem = deepClone(this.serviceGoodsList).find(item => item.serviceGoodsId === this.currentServiceGoodsId)
        return !!goodsItem ? goodsItem.goodsName : ''
    }

    @computed get selectedMonths() {
        return this.upgradeType === 'all' ? deepClone(this.costInfo).upgradeMonth : this.months
    }

    @computed get totalPrice() {
        return this.upgradeType === 'all' ? Number(deepClone(this.costInfo).upgradeMonth) * this.unitPrice : this.months * this.unitPrice
    }

    @action
    setEffectiveNow = value => {
        this.effectiveNow = value
    }

    @action
    setIsEffectCurrentMonth = value => {
        this.isEffectCurrentMonth = value
    }

    @action
    setCurrentServiceGoodsId = id => {
        this.currentServiceGoodsId = id
    }

    @action
    setServiceGoodsInfo = info => {
        this.currentServiceGoodsInfo = info
    }

    @action
    setUpgradeType = value => {
        this.upgradeType = value
    }

    @action
    setMonths = value => {
        this.months = Number(value)
    }

    @action
    setUnitPrice = value => {
        this.unitPrice = Number(value)
    }

    @action
    setServiceGoodsList = value => {
        this.serviceGoodsList = value
    }

    @action
    setCostInfo = value => {
        this.costInfo = value
    }

    @action
    getUpgradePackageList = async (userGoodsId) => {
        try {
            const res = await this.api.queryService({userGoodsId})
            res.map(item => {
                item.infoLists = !!item.goodsInfo ? item.goodsInfo.split('\n') : []
            })
            this.setIsEffectCurrentMonth(res[0].effectiveNow)
            this.setEffectiveNow(res[0].effectiveNow)
            this.setCurrentServiceGoodsId(res[0].serviceGoodsId)
            this.setServiceGoodsInfo(res[0].infoLists)
            await this.calculateUpgradeCost({
                effectiveNow: res[0].effectiveNow,
                serviceGoodsId: res[0].serviceGoodsId,
                userGoodsId: userGoodsId
            })
            this.setServiceGoodsList(res)
        } catch (e) {
            throw new Error(e)
        }
    }

    @action
    calculateUpgradeCost = async ({serviceGoodsId, userGoodsId, effectiveNow}) => {
        try {
            const res = await this.api.caculateUpgradeCost({
                serviceGoodsId: serviceGoodsId,
                userGoodsId: userGoodsId,
                effectiveNow: effectiveNow
            })
            this.setUnitPrice(Number(res.upgradeCost || 0) / Number(res.upgradeMonth))
            this.setCostInfo(res)
        } catch (e) {
            throw new Error(e)
        }
    }

    @action
    generateUpgradeOrder = async ({userGoodsId, iccid, payment}) => {
        try {
            const res = await this.api.upgradePlan({
                userGoodsId: userGoodsId,
                serviceGoodsId: this.currentServiceGoodsId,
                paymentType: payment,
                iccid: iccid,
                effectiveNow: this.isEffectCurrentMonth,
                upgradeMonth: this.selectedMonths
            })
            localStorage.setItem('H5_URL_ORIGIN', JSON.stringify('ordering-upgrade'))
            this.goToPath(`/app/ordering/payorder/paying/${res}/${payment}/1/true`)
        } catch (e) {
            throw new Error(e)
        }
    }

    @action
    resetData = () => {
        this.setIsEffectCurrentMonth('1')
        this.setServiceGoodsInfo([])
        this.setCurrentServiceGoodsId('')
        this.setCostInfo({})
        this.setMonths(6)
        this.setServiceGoodsList([])
        this.setUnitPrice(0)
        this.setUpgradeType('all')
    }
}

const upgradeStore = new UpgradeStore()
export {
    upgradeStore, UpgradeStore
}
